export default __webpack_public_path__ + "static/media/macbeth.912f383f.png";